function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16,15 L4,15 C3.447,15 3,14.553 3,14 C3,13.447 3.447,13 4,13 L16,13 C16.553,13 17,13.447 17,14 C17,14.553 16.553,15 16,15 M18,10 L2,10 C0.896,10 0,10.896 0,12 L0,16 C0,17.104 0.896,18 2,18 L18,18 C19.104,18 20,17.104 20,16 L20,12 C20,10.896 19.104,10 18,10 M16,5 L4,5 C3.447,5 3,4.553 3,4 C3,3.447 3.447,3 4,3 L16,3 C16.553,3 17,3.447 17,4 C17,4.553 16.553,5 16,5 M18,0 L2,0 C0.896,0 0,0.896 0,2 L0,6 C0,7.104 0.896,8 2,8 L18,8 C19.104,8 20,7.104 20,6 L20,2 C20,0.896 19.104,0 18,0",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-1 -2 22 22"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/category.cf647104.svg";
export { SvgComponent as ReactComponent };